/**
 * Surviving slice of the retired structures list: the plant (site group)
 * currently selected in the app, read across the left nav, breadcrumbs, and the
 * site-dashboard chrome.
 */
import { SET_PLANT } from '@sophocles/features/sites/slices/selectedPlant/actions';

const initialState = { selectedPlant: 0 };

function structureListReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PLANT:
      return { ...state, selectedPlant: action.plant };
    default:
      return state;
  }
}

export default structureListReducer;
